import { motion } from 'framer-motion';

export const TabsSkeleton = () => {
  return (
    <div className='flex flex-1 flex-col rounded-lg border border-outline-variant'>
      {/* Tab Headers Skeleton */}
      <div className='bg-blue-900/20 relative overflow-hidden rounded-t-lg'>
        <div className='relative z-10 flex'>
          {['Attributes', 'Jobs', 'Deployments'].map((label, index) => (
            <div
              key={label}
              className='bg-surface flex-1 border-r border-outline-variant px-6 py-4 last:border-r-0'
            >
              <div className='h-5 w-20 animate-pulse rounded bg-gray-200' />
            </div>
          ))}
        </div>

        {/* Active indicator skeleton */}
        <motion.div
          className='absolute bottom-0 left-0 h-full w-1/3 animate-pulse bg-gray-300'
          animate={{ opacity: [0.3, 0.7, 0.3] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        />
      </div>

      {/* Tab Content Skeleton */}
      <div className='flex flex-1 flex-col bg-surface-container-background p-6'>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.1 }}
          className='space-y-4'
        >
          {/* Search bar skeleton */}
          <div className='h-10 w-full animate-pulse rounded-md bg-gray-200' />

          {/* Content rows skeleton */}
          <div className='h-10 w-full animate-pulse rounded-md bg-gray-200' />

          {/* Content rows skeleton */}
          <div className='h-10 w-full animate-pulse rounded-md bg-gray-200' />
          {/* Content rows skeleton */}
          <div className='h-10 w-full animate-pulse rounded-md bg-gray-200' />

          {/* Content rows skeleton */}
          <div className='h-10 w-full animate-pulse rounded-md bg-gray-200' />
        </motion.div>
      </div>
    </div>
  );
};
